import { EditOutlined } from '@ant-design/icons';
import { Col, Row, Space, Typography } from 'antd';
import React from 'react';

import { WEEK_DAYS_MON_START } from '@/constants/date';

import type { VenueEditFormValues } from '../../../../types';
import { getDisplayOperatingHours } from '../../helpers';

const { Text } = Typography;

type OperatingHourListProps = {
  operatingHours: VenueEditFormValues['operatingHours'];
  openEditOpeningHoursModal: (tabKey: string) => void;
};

export const OperatingHourList = ({
  operatingHours,
  openEditOpeningHoursModal,
}: OperatingHourListProps) => {
  return (
    <Space direction="vertical" className="w-full">
      {WEEK_DAYS_MON_START.map((day, index) => {
        const dailyOperatingHours = operatingHours[index];
        const openingHours = getDisplayOperatingHours(dailyOperatingHours);
        const isArray = Array.isArray(openingHours);

        return (
          <Row key={day}>
            <Col flex={2}>
              <Space>
                <Text>{`星期${day}`}</Text>
                <EditOutlined
                  rev={undefined}
                  onClick={() => openEditOpeningHoursModal(index.toString())}
                />
              </Space>
            </Col>

            {isArray ? (
              <Col flex={3}>
                <Space direction="vertical" size={0} className="w-full">
                  {openingHours.map((timePeriod, index) => {
                    return <Text key={index}>{timePeriod}</Text>;
                  })}
                </Space>
              </Col>
            ) : (
              <Col flex={3}>{openingHours}</Col>
            )}
          </Row>
        );
      })}
    </Space>
  );
};
